import { Outlet } from 'react-router'
Outlet.displayName = 'Outlet'

export { Outlet }
